import { get, post } from '@/api/core'
import {
  getProductOrientation,
  toBackendProjectCategory,
  toBackendProductServiceCategory,
  toProjectType,
} from '@/helpers/productCategory'

export namespace project {
  /** 创建 */
  export function projectCreate(body: ProjectModels.CreateProjectParam) {
    const { durationCategory, ...restBody } = body
    const isPortrait = getProductOrientation(body.projectCategory) === 'portrait'
    return post<{ projectId: number }>('/advert/add', {}, {
      ...restBody,
      projectType: toProjectType(body.projectCategory),
      taskType: isPortrait ? 'portrait' : 'landscape',
      ...(isPortrait ? { durationCategory } : {}),
      projectCategory: toBackendProjectCategory(body.projectCategory),
    })
  }

  export function projectUpdate(body: {
    projectId: number
    projectName?: string
    brandName?: string
    adName?: string
  }) {
    return post('/advert/update', {}, body)
  }

  export function projectDetail(projectId: number, language?: ProjectModels.LanguageType) {
    return get<{
      data: ProjectModels.ProjectDetail
      hasTranslated: boolean
    }>('/advert/one', { projectId, language })
  }

  export function projectDetailV3(projectId: number) {
    return get<{ data: ProjectModels.ProjectDetailV3 }>('/advert/survey/one', { projectId })
  }

  export function startPptTranslate(projectId: number, language: ProjectModels.UseLanguage) {
    return post<{ data: ProjectModels.PptTranslateResult }>(
      '/advert/survey/ppt/translate/start',
      {},
      { projectId, language }
    )
  }

  export function pollPptTranslate(projectId: number, language: ProjectModels.UseLanguage) {
    return get<{ data: ProjectModels.PptTranslateResult }>(
      '/advert/survey/ppt/translate/poll',
      { projectId, language }
    )
  }

  export function projectDelete(projectId: number) {
    return post('/advert/delete', {}, { projectId })
  }

  export function projectList(param: {
    pageNo: number
    pageSize: number
    keyword?: string
    orderBy?: string
    norm?: 1 | 2
    status?: ProjectModels.ProjectListItem['status']
    durationCategory?: ProjectModels.DurationCategory
    taskType: 'landscape' | 'portrait'
    projectCategory?: ProjectModels.ProjectCategory
  }) {
    const params = param.projectCategory
      ? {
        pageNo: param.pageNo,
        pageSize: param.pageSize,
        keyword: param.keyword,
        orderBy: param.orderBy,
        norm: param.norm,
        status: param.status,
        durationCategory: param.durationCategory,
        projectCategory: toBackendProductServiceCategory(param.projectCategory),
      }
      : param
    return get<{
      objects: ProjectModels.ProjectListItem[]
      hasNext: boolean
      pageNo: number
      pageSize: number
      totalCount: number
      allCount?: number
      generateCount?: number
      splashCount?: number
    }>('/advert/list', params)
  }

  export function projectProgress(projectIds: number[]) {
    return post<{
      data: Record<
        number | string,
        { process: number; status: ProjectModels.ProjectListItem['status'] }
      >
    }>('/advert/progress', {}, { projectIds })
  }

  export function projectRetry(projectId: number) {
    return post('/advert/retry', {}, { projectId })
  }

  /** 翻译状态 */
  export function projectTranslateStatus(projectId: number, language: ProjectModels.LanguageType) {
    return get<{ translateStatus: 'no_tasks' | 'ongoing' | 'completed' | 'failed' }>(
      '/advert/one/translate/status',
      { projectId, language }
    )
  }

  /** 检查公司当前正在分析中的项目数是否超过了3个 */
  export function checkWaiting() {
    return get<{ canAnalyse: boolean }>('/advert/can_analyse')
  }
}
